import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '..';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  DeafCommJoinContent,
  Footer,
} from '../../components';
import config from '../../config';

import css from './DeafCommJoinPage.module.css';

const DeafCommJoinPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const tabs = [
    {
      text: intl.formatMessage({ id: 'JoinUsPage.joinusTabTitle' }),
      selected: false,
      linkProps: {
        name: 'JoinUsPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CommProfJoinPage.commprofTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CommProfJoinPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'DeafCommJoinPage.deafcommTabTitle' }),
      selected: true,
      linkProps: {
        name: 'DeafCommJoinPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'InvestorsJoinPage.investorsTabTitle' }),
      selected: false,
      linkProps: {
        name: 'InvestorsJoinPage',
      },
    },
  ];
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'DeafCommJoinPage.schemaTitle' }, { siteTitle });
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };
  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="CommProfJoinPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain>
          <div className={css.content}>
            <h1 className={css.heading}>
              <FormattedMessage id="DeafCommJoinPage.heading" />
            </h1>
            <DeafCommJoinContent />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

DeafCommJoinPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const DeafCommJoinPage = compose(
  connect(mapStateToProps),
  injectIntl
)(DeafCommJoinPageComponent);

export default DeafCommJoinPage;
